import {ChangeDetectorRef, Inject, Optional, Pipe, PipeTransform} from '@angular/core';
import {SearchAgreementsRepresentation} from '@aztrix/sdk';
import {LANGUAGE_OVERRIDE, TranslatePipe, TranslateService} from '@aztrix/translate';
import {BehaviorSubject} from 'rxjs';

@Pipe({
  name: 'agreementStatusLabel',
  pure: false,
})
export class AgreementStatusLabelPipe implements PipeTransform {
  private _translatePipe: TranslatePipe;
  constructor(
    translate: TranslateService,
    changeDetector: ChangeDetectorRef,
    @Optional()
    @Inject(LANGUAGE_OVERRIDE)
    languageOverride$?: BehaviorSubject<string | undefined>
  ) {
    this._translatePipe = new TranslatePipe(translate, changeDetector, languageOverride$);
  }

  transform(status: SearchAgreementsRepresentation.AgreementStatusEnum | undefined): string {
    let translateKey = '';
    switch (status) {
      case SearchAgreementsRepresentation.AgreementStatusEnum.ACTIVE:
        translateKey = 'agreement.active';
        break;
      case SearchAgreementsRepresentation.AgreementStatusEnum.EXPIRED:
        translateKey = 'agreement.expired';
        break;
      default:
        break;
    }
    return this._translatePipe.transform(translateKey);
  }
}
